// Haber "zamanlanmış yayın" filtresi.
// yayin_tarihi'si gelecekte olan haberler, o an gelene kadar sitede/aramada/asistanda
// GÖRÜNMEZ (Strapi'de Published olsalar bile). Böylece CMS'ten ileri tarih vererek
// gerçek zamanlama yapılabilir. (Tüm haberlerde yayin_tarihi dolu; null yok → basit $lte.)
//
// URL'e "&" ile eklenir: `${endpoint}?...&${yayinTarihiLteNow()}`
export function yayinTarihiLteNow() {
  // Dakikaya yuvarla ki URL dakika boyunca sabit kalsın (gereksiz cache-bypass olmaz).
  const t = Math.floor(Date.now() / 60000) * 60000;
  return `filters[yayin_tarihi][$lte]=${encodeURIComponent(new Date(t).toISOString())}`;
}
